import { h } from 'preact';
import { useState } from 'preact/hooks';
import { api } from '../../state/auth.js';
import Card from './Card.jsx';
import Button from './Button.jsx';

// On your own profile: change your password. Other devices are signed out afterwards.

const ERRORS = {
  wrong_password: 'Je huidige wachtwoord klopt niet.',
  invalid_input: 'Vul alle velden in; het nieuwe wachtwoord moet 8 tot 72 tekens zijn.',
  same_password: 'Kies een ander wachtwoord dan je huidige.',
  password_recently_used: 'Dit wachtwoord heb je kort geleden al gebruikt. Kies een ander.',
  account_locked: 'Te vaak een verkeerd wachtwoord. Probeer het over 15 minuten opnieuw.',
};
const EMPTY = { current: '', next: '', confirm: '' };

export default function PasswordCard() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(null);
  const set = key => e => setForm(f => ({ ...f, [key]: e.target.value }));

  async function save(e) {
    e.preventDefault();
    setError(null); setDone(null);
    if (form.next.length < 8) return setError('Je nieuwe wachtwoord moet minimaal 8 tekens bevatten.');
    if (form.next !== form.confirm) return setError('De nieuwe wachtwoorden komen niet overeen.');
    setBusy(true);
    try {
      const r = await api('/api/users/password', { method: 'POST', body: JSON.stringify({ currentPassword: form.current, newPassword: form.next }) });
      setForm(EMPTY); setOpen(false);
      setDone(r.other_sessions_signed_out
        ? `Je wachtwoord is gewijzigd. Je bent uitgelogd op ${r.other_sessions_signed_out} ander${r.other_sessions_signed_out === 1 ? ' apparaat' : 'e apparaten'}.`
        : 'Je wachtwoord is gewijzigd.');
    } catch (err) { setError(ERRORS[err.code] || 'Wijzigen lukte niet. Probeer het opnieuw.'); }
    setBusy(false);
  }

  return (
    <Card title="🔒 Wachtwoord">
      {done && <div class="text-sm" style="color:var(--color-success,#16a34a);margin-bottom:8px">✓ {done}</div>}
      {!open ? (
        <div style="display:flex;flex-direction:column;gap:8px;align-items:flex-start">
          <div class="text-sm text-muted">Wijzig je wachtwoord. Andere apparaten waar je bent ingelogd, worden daarna uitgelogd.</div>
          <Button size="sm" variant="secondary" onClick={() => { setOpen(true); setDone(null); }}>Wachtwoord wijzigen</Button>
        </div>
      ) : (
        <form onSubmit={save} style="display:flex;flex-direction:column;gap:10px;max-width:360px">
          <div class="form-group" style="margin:0">
            <label class="form-label" for="pw-current">Huidig wachtwoord</label>
            <input id="pw-current" class="form-input" type="password" autoComplete="current-password" value={form.current} onInput={set('current')} required />
          </div>
          <div class="form-group" style="margin:0">
            <label class="form-label" for="pw-next">Nieuw wachtwoord</label>
            <input id="pw-next" class="form-input" type="password" autoComplete="new-password" minLength={8} maxLength={72} value={form.next} onInput={set('next')} placeholder="8 tot 72 tekens" required />
          </div>
          <div class="form-group" style="margin:0">
            <label class="form-label" for="pw-confirm">Herhaal nieuw wachtwoord</label>
            <input id="pw-confirm" class="form-input" type="password" autoComplete="new-password" value={form.confirm} onInput={set('confirm')} required />
          </div>
          {error && <div class="alert alert-error" style="margin:0">{error}</div>}
          <div style="display:flex;gap:8px">
            <Button type="submit" size="sm" disabled={busy}>{busy ? 'Bezig…' : 'Opslaan'}</Button>
            <Button type="button" size="sm" variant="secondary" disabled={busy} onClick={() => { setOpen(false); setForm(EMPTY); setError(null); }}>Annuleren</Button>
          </div>
        </form>
      )}
    </Card>
  );
}
